export default {
  setReceiptsHierarchies(hierarchies) {
    localStorage.setItem('receiptsHierarchies', JSON.stringify(hierarchies));
  },
  getReceiptsHierarchies() {
    const hierarchies = localStorage.getItem('receiptsHierarchies');

    return hierarchies ? JSON.parse(hierarchies) : [];
  },
  removeReceiptsHierarchies() {
    localStorage.removeItem('receiptsHierarchies');
  }
};
